import { Solutions } from "components/EtudeForm/Solutions";
import { SolutionDetails } from "components/EtudeForm/Solutions/SolutionDetails";
import {
  Navigate,
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  generatePath,
} from "react-router";
import RootRoute from "RootRoute";
import Layout from "../layout";
import { APP_URL, getDefaultNetwork } from "../utils/defines";
import { CGU } from "./CGU";
import { EtudePage } from "./etudes/EtudePage";
import { FAQPage } from "./FAQPage";
import { HomePage } from "./HomePage";
import { LoginPage } from "./LoginPage";
import { ProfilePage } from "./ProfilePage";
import Template from "./template";
import { WSOPage } from "./WSOPage";
import { SolutionAccessoires } from "components/EtudeForm/Solutions/SolutionDetails/SolutionAccessoires";
import { MyEtudesPage } from "./etudes/MyEtudesPage";
import { SolutionDocuments } from "components/EtudeForm/Solutions/SolutionDetails/SolutionDocuments";
import { EtudeLayout } from "components/EtudeForm/EtudeLayout";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RootRoute />}>
      <Route
        index
        element={
          <Navigate
            to={generatePath(APP_URL.Base, { network: getDefaultNetwork() })}
            replace
          />
        }
      />

      <Route path={APP_URL.WSOCallback} element={<WSOPage />} />
      <Route path={APP_URL.Base} element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path={APP_URL.Login} element={<LoginPage />} />
        <Route path={APP_URL.CGU} element={<CGU />} />
        <Route path={APP_URL.FAQ} element={<FAQPage />} />
        <Route path={APP_URL.Profile} element={<ProfilePage />} />
        <Route path={APP_URL.MyEtudes} element={<MyEtudesPage />} />
        <Route path={APP_URL.Etude} element={<EtudeLayout />}>
          <Route
            path={APP_URL.SolutionDetailAccesories}
            element={<SolutionAccessoires />}
          />
          <Route path={APP_URL.SolutionDetails} element={<SolutionDetails />} />
          <Route path={APP_URL.Solutions} element={<Solutions />} />
          <Route
            path={APP_URL.SolutionDetailDocuments}
            element={<SolutionDocuments />}
          />
          <Route index element={<EtudePage />} />
        </Route>
        <Route path={APP_URL.Template}>
          <Route path="" element={<Template />} />
        </Route>
        <Route path="*" element={<Navigate to={""} replace />} />
      </Route>
    </Route>
  )
);
